// Core languages that come bundled with Prism
export const CORE_LANGUAGES = [
    'clike',
    'css',
    'html',
    'markup',
    'mathml',
    'svg',
    'xml'
];

export const LANGUAGE_MODULE_MAP = {
    // Core language needed as dependency
    javascript: () => import('prismjs/components/prism-javascript'),

    // Additional/custom languages
    bash: () => import('prismjs/components/prism-bash'),
    graphql: () => import('prismjs/components/prism-graphql'),
    ini: () => import('prismjs/components/prism-ini'),
    json: () => import('prismjs/components/prism-json'),
    json5: () => import('prismjs/components/prism-json5'),
    jsx: () => import('prismjs/components/prism-jsx'),
    makefile: () => import('prismjs/components/prism-makefile'),
    markdown: () => import('prismjs/components/prism-markdown'),
    scss: () => import('prismjs/components/prism-scss'),
    sql: () => import('prismjs/components/prism-sql'),
    tsx: () => import('prismjs/components/prism-tsx'),
    typescript: () => import('prismjs/components/prism-typescript'),
    yaml: () => import('prismjs/components/prism-yaml')
    // Add more languages as needed (NOTE: Be mindful of bundle size and
    // dependencies)
};

export const LANGUAGE_DEPENDENCIES = {
    json: ['javascript'],
    json5: ['json'],
    jsx: ['javascript'],
    tsx: ['typescript', 'jsx'],
    typescript: ['javascript']
};
